<template>
  <h2>エラー</h2>
  <div id="content">
    <section class="basic mb-5">
      <p class="exp fs-15">
        ご指定いただいたURLの有効期限が切れているか、正常なアクセスではない可能性があります。
      </p>
      <p class="exp">恐れ入りますが、もう一度お手続きをお願いいたします。</p>
    </section>
  </div>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  mounted() {
    auth.removeNoLoginUid();
    window.scroll(0, 0);
  },
}
</script>